let triggerSnackbar = null;

const SnackbarNotify = {
    setTrigger(fn) {
        triggerSnackbar = fn;
    },
    success(message, options = {}) {
        triggerSnackbar &&
            triggerSnackbar(message, {
                ...options,
                variant: 'success',
                alert: { color: 'success', variant: 'outlined' }
            });
    },
    error(message, options = {}) {
        triggerSnackbar &&
            triggerSnackbar(message, {
                ...options,
                variant: 'error',
                alert: { color: 'error', variant: 'outlined' }
            });
    },
    info(message, options = {}) {
        triggerSnackbar &&
            triggerSnackbar(message, {
                ...options,
                variant: 'info',
                alert: { color: 'info', variant: 'outlined' }
            });
    },
    warning(message, options = {}) {
        triggerSnackbar &&
            triggerSnackbar(message, {
                ...options,
                variant: 'warning',
                alert: { color: 'warning', variant: 'outlined' }
            });
    },
    custom(message, options = {}) {
        triggerSnackbar &&
            triggerSnackbar(message, {
                ...options,
                variant: options.variant || 'default'
            });
    }
};

export const registerSnackbar = fn => {
    SnackbarNotify.setTrigger(fn);
};

export default SnackbarNotify;
